import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './styles.css';

class EmptyState extends Component {
  render() {
    const {
      className, message, children, theme, noBorder, fullWidth
    } = this.props;
    return (
      <div style={{...(noBorder && { border: 'none' }), ...(fullWidth && {width: '100%'})}} className={`EmptyState ${className || ''}`}>
        <p className={`EmptyState__message ${theme === 'light' ? 'EmptyState__message--light' : ''}`}>{message}</p>
        {children}
      </div>
    );
  }
}

EmptyState.propTypes = {
  message: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default EmptyState;
